import useCompany from "modules/company/hooks/useCompany";
import React from "react";
import useAuth from "../auth/hooks/useAuth";

const AuthVerify = () => {
  const auth = useAuth();
  const { loadCompany } = useCompany();

  React.useEffect(() => {
    if (auth.isAuthenticated) {
      loadCompany();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  React.useEffect(() => {
    const unsubscribe = auth.subscribe();
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AuthVerify;
